export const props = {
  label: {
    type: String,
    default: '',
  },
  submit: {
    type: Boolean,
    default: false,
  },
};

export const render = (createElement, self) => createElement(
  'button',
  {
    attrs: {
      type: self.type,
    },
    class: `btn btn-${self.variant}`,
    on: {
      click: () => {
        self.$emit('click');
      },
    },
  },
  [
    createElement('icon'),
    createElement(
      'span',
      {
        class: 'd-inline-block ml-2',
      },
      [self.computedLabel],
    ),
  ],
);

export const computed = {
  computedLabel() {
    if (this.label) {
      return this.label;
    }
    return this.$t('Label');
  },
  type() {
    if (this.submit) {
      return 'submit';
    }
    return 'button';
  },
};

export default {};
